import { api } from "../configs/axiosConfigs";

const SolarCalculatorApiService = {
  // محاسبه ماشین حساب خورشیدی (Public API)
  calculateSolarSystem: async (inputData) => {
    const response = await api.request({
      url: "SolarCalculator/Calculate",
      method: "POST",
      data: inputData,
    });
    return response.data;
  },

  // دریافت لیست استان‌ها و شهرها (Public API)
  getProvincesAndCities: async () => {
    const response = await api.request({
      url: "SolarCalculator/GetProvincesAndCities",
      method: "GET",
    });
    return response.data;
  },

  // دریافت قیمت‌های پیشنهادی (Public API)
  getSuggestedPrices: async () => {
    const response = await api.request({
      url: "SolarCalculator/GetSuggestedPrices",
      method: "GET",
    });
    return response.data;
  },

  // ثبت درخواست مشاوره رایگان (Public API)
  requestConsultation: async (inputData) => {
    const response = await api.request({
      url: "SolarCalculator/RequestConsultation",
      method: "POST",
      data: inputData,
    });
    return response.data;
  },

  // دریافت آمار محاسبات (Admin API - با احراز هویت)
  getCalculationStatistics: async () => {
    const response = await api.request({
      url: "SolarCalculator/GetCalculationStatistics",
      method: "GET",
    });
    return response.data;
  },

  // دریافت لیست محاسبات (Admin API - با احراز هویت)
  getCalculations: async (
    page = 1,
    pageSize = 20,
    consultationOnly = false
  ) => {
    const response = await api.request({
      url: "SolarCalculator/GetCalculations",
      method: "GET",
      params: { page, pageSize, consultationOnly },
    });
    return response.data;
  },

  // دریافت جزئیات یک محاسبه (Admin API - با احراز هویت)
  getCalculationById: async (id) => {
    const response = await api.request({
      url: "SolarCalculator/GetCalculationById",
      method: "GET",
      params: { id },
    });
    return response.data;
  },
};

export default SolarCalculatorApiService;
